import StandardQueryTable from "@/components/StandardQueryTable";
import DictionaryCreator from "@/components/dictionaries/DictionaryCreator";
import DictionaryEditor from "@/components/dictionaries/DictionaryEditor";
import { PATH_DICTS_TAX_OFFICES } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import { readTaxOffice, writeTaxOffice } from "@/schemas/taxOffice";
import { TaxOfficeService } from "@/services/taxOffice";
import { ReadTaxOffice, WriteTaxOffice } from "@/types/taxOffice";
import { Building2 } from "lucide-react";

const id = Module.TaxOffices;
const path = PATH_DICTS_TAX_OFFICES;
const ns = "taxOffices";

const config: DictionaryConfig<ReadTaxOffice, WriteTaxOffice> = {
  id,
  ns,
  service: TaxOfficeService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeTaxOffice,
  defaultValues: {
    code: 0,
    name: "",
  },
  Icon: Building2,
  List: () => (
    <StandardQueryTable<ReadTaxOffice>
      schema={readTaxOffice}
      name={ns}
      fetchList={TaxOfficeService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.TaxOffices },
      }}
    />
  ),
  Creator: DictionaryCreator,
  Editor: DictionaryEditor,
};

export default config;
